import { __ } from "@wordpress/i18n";
import * as Icon from "../components/Icon";

export const ROUTES = [
	{
		route: "/dashboard",
		label: __("Dashboard", "magazine-blocks"),
	},
	{
		route: "/blocks",
		label: __("Blocks", "magazine-blocks"),
	},
	{
		route: "/site-builder",
		label: __("Template Builder", "magazine-blocks"),
	},
	{
		route: "/products",
		label: __("Products", "magazine-blocks"),
	},
	{
		route: "/settings",
		label: __("Settings", "magazine-blocks"),
	},
	{
		route: "/free-vs-pro",
		label: __("Free vs Pro", "magazine-blocks"),
	},
	{
		route: "/help",
		label: __("Help", "magazine-blocks"),
	},
];

export const CHANGELOG_TAG_COLORS = {
	fix: {
		color: "primary.500",
		bgColor: "primary.100",
		scheme: "primary",
	},
	feature: {
		color: "green.500",
		bgColor: "green.50",
		scheme: "green",
	},
	enhancement: {
		color: "teal.500",
		bgColor: "teal.50",
		scheme: "teal",
	},
	added: {
		color: "pink.500",
		bgColor: "pink.50",
		scheme: "pink",
	},
	update: {
		color: "orange.500",
		bgColor: "orange.50",
		scheme: "orange",
	},
	tweak: {
		color: "purple.500",
		bgColor: "purple.50",
		scheme: "purple",
	},
};

export const BLOCKS = {
	section: {
		label: __("Section", "magazine-blocks"),
		icon: Icon.Section,
		type: "free",
	},
	heading: {
		label: __("Heading", "magazine-blocks"),
		icon: Icon.Heading,
		type: "free",
	},
	paragraph: {
		label: __("Paragraph", "magazine-blocks"),
		icon: Icon.Paragraph,
		type: "free",
	},
	button: {
		label: __("Button", "magazine-blocks"),
		icon: Icon.Slider,
		type: "free",
	},
	image: {
		label: __("Image", "magazine-blocks"),
		icon: Icon.Image,
		type: "free",
	},
	icon: {
		label: __("Icon", "magazine-blocks"),
		icon: Icon.Icon,
		type: "free",
	},
	"social-icons": {
		label: __("Social Icons", "magazine-blocks"),
		icon: Icon.SocialIcons,
		type: "free",
	},
	advertisement: {
		label: __("Advertisement", "magazine-blocks"),
		icon: Icon.Advertisement,
		type: "free",
	},
	"date-weather": {
		label: __("Date & Weather", "magazine-blocks"),
		icon: Icon.DateWeather,
		type: "free",
	},
	"news-ticker": {
		label: __("News Ticker", "magazine-blocks"),
		icon: Icon.NewsTicker,
		type: "free",
	},
	modal: {
		label: __("Pop Up", "blockart"),
		icon: Icon.Modal,
		type: "free",
	},
	"banner-posts": {
		label: __("Banner Posts", "magazine-blocks"),
		icon: Icon.BannerPosts,
		type: "free",
	},
	"grid-module": {
		label: __("Grid Module", "magazine-blocks"),
		icon: Icon.GridModule,
		type: "free",
	},
	"featured-posts": {
		label: __("Featured Posts", "magazine-blocks"),
		icon: Icon.FeaturedPosts,
		type: "free",
	},
	"post-video": {
		label: __("Post Video", "magazine-blocks"),
		icon: Icon.PostVideo,
		type: "free",
	},
	"tab-post": {
		label: __("Tab Post", "magazine-blocks"),
		icon: Icon.TabPost,
		type: "free",
	},
	"post-list": {
		label: __("Post List", "magazine-blocks"),
		icon: Icon.PostList,
		type: "free",
	},
	slider: {
		label: __("Post Slider", "magazine-blocks"),
		icon: Icon.Slider,
		type: "free",
	},
	"latest-posts": {
		label: __("Latest Posts", "magazine-blocks"),
		icon: Icon.LatestPosts,
		type: "free",
	},
	"featured-categories": {
		label: __("Split Feed", "magazine-blocks"),
		icon: Icon.FeaturedCategories,
		type: "free",
	},
	"category-list": {
		label: __("Category List", "magazine-blocks"),
		icon: Icon.CategoryList,
		type: "free",
	},
	chart: {
		label: __("Chart", "magazine-blocks"),
		icon: Icon.Chart,
		type: "pro",
	},
	"video-scrolling": {
		label: __("Video Scrolling", "magazine-blocks"),
		icon: Icon.VideoScrolling,
		type: "pro",
	},
	"video-popup": {
		label: __("Video Popup", "magazine-blocks"),
		icon: Icon.VideoPopup,
		type: "pro",
	},
	"split-content": {
		label: __("Split Content", "magazine-blocks"),
		icon: Icon.SplitContent,
		type: "pro",
	},
	tabs: {
		label: __("Tabs", "magazine-blocks"),
		icon: Icon.Tabs,
		type: "pro",
	},
};

export const SETTINGS_TABS = [
	{
		label: __("Editor Options", "magazine-blocks"),
		icon: Icon.Cog,
	},
	{
		label: __("Asset Generation", "magazine-blocks"),
		icon: Icon.ArrowsRepeat,
	},
	{
		label: __("Performance", "magazine-blocks"),
		icon: Icon.Meter,
	},
	{
		label: __("Version Control", "magazine-blocks"),
		icon: Icon.ThreeCircleNodes,
	},
	{
		label: __("Integrations", "magazine-blocks"),
		icon: Icon.ArrowsUpDown,
	},
	{
		label: __("Maintenance Mode", "magazine-blocks"),
		icon: Icon.CirclesInsideCircle,
	},
];
